exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daxie[data-v-a33054f2]{color:#999;font-size:13px}\n", ""]);

// exports
